<template>
  <v-card class="rsl-fixed-height">
    <v-card-title class="ml-10">
      <div class="text-h5">{{ $t('CASES.HISTORIC.VIEW_CASE.TITLE') }} {{ historicCaseId }} ({{ processDefinitionKey }})</div>
      <v-spacer></v-spacer>
      <v-btn 
        small
        class="mr-2"
        color="warning"
        @click="obfuscate()"
      >{{ $t('CASES.HISTORIC.VIEW_CASE.BTNS.OBFUSCATE_DATA') }}</v-btn>
      <v-btn 
        small
        class="mr-2"
        color="secondary"
        @click="close"
      >{{ $t('GENERAL.BTNS.CLOSE') }}</v-btn>
    </v-card-title>

    <v-tabs v-model="tab">
      <v-tab
        v-for="task in historicTasks"
        :key="task.id"
      >
        {{ task.name }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="task in historicTasks"
        :key="task.id"
      >
        <v-card
          flat
        >
          <v-card-text>
            <v-container class="width-override">
              <v-row>
                <v-col class="col-md-3">
                  <div class="text-h5">{{ $t('CASES.HISTORIC.VIEW_CASE.TASK_INFO_TITLE') }}</div>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="col-md-3">
                  {{ $t('CASES.HISTORIC.VIEW_CASE.FIELDS.TASK_START') }}
                </v-col>
                <v-col class="col-md-3">
                  {{ task.startTime }}
                </v-col>
              </v-row>
              <v-row>
                <v-col class="col-md-3">
                  {{ $t('CASES.HISTORIC.VIEW_CASE.FIELDS.TASK_END') }}
                </v-col>
                <v-col class="col-md-3">
                  {{ task.endTime }}
                </v-col>
              </v-row>
              <v-row>
                <v-col class="col-md-3">
                  {{ $t('CASES.HISTORIC.VIEW_CASE.FIELDS.TASK_ASSIGNED') }}
                </v-col>
                <v-col class="col-md-3">
                  {{ task.assignee }}
                </v-col>
              </v-row>
              <v-row v-if="task.due !== null">
                <v-col class="col-md-3">
                  {{ $t('CASES.HISTORIC.VIEW_CASE.FIELDS.TASK_DUE') }}
                </v-col>
                <v-col class="col-md-3">
                  {{ task.due }}
                </v-col>
              </v-row>
              <v-row v-if="task.followUp !== null">
                <v-col class="col-md-3">
                  {{ $t('CASES.HISTORIC.VIEW_CASE.FIELDS.TASK_FOLLOW_UP') }}
                </v-col>
                <v-col class="col-md-3">
                  {{ task.followUp }}
                </v-col>
              </v-row>

              <v-row>
                <v-col class="col-md-3">
                  <div class="text-h5">{{ $t('CASES.HISTORIC.VIEW_CASE.TASK_VAR_TITLE') }}</div>
                </v-col>
              </v-row>

              <v-row class="col-md-12">
                <v-data-table 
                  class="col-md-12"
                  :headers="historicHeaders" 
                  :items="historicVars[task.id]" 
                  item-key="id"
                  sort-by="time"
                  :items-per-page="15"
                  loading-text="Loading... Please wait"
                  :loading="loading">
                </v-data-table>
              </v-row>

            </v-container>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="600"
      v-model="obfuscateDialog"
      :retain-focus="false"
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ obfuscateTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ obfuscateText }}</div>
            <v-data-table 
              v-model="obfuscateData" 
              :headers="obfuscateHeaders" 
              :items="obfuscateItems" 
              item-key="id"
              show-select>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-btn
              class="mr-2"
              color="secondary"
              @click="cancelObfuscation()"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              class="mr-2"
              color="error"
              :disabled="obfuscateData.length == 0"
              @click="confirmObfuscation()"
            >{{ $t('CASES.HISTORIC.VIEW_CASE.BTNS.OBFUSCATE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="600"
      v-model="obfuscateConfirmDialog"
      :retain-focus="false"
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ obfuscateConfirmTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ obfuscateConfirmText }}</div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              class="mr-2 float-right"
              color="secondary"
              @click="obfuscateConfirmClose()"
            >{{ $t('GENERAL.BTNS.CLOSE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'viewcasehistory',
    computed: {
      ...mapGetters(['historicTasks', 'historicVariables', 'instanceId', 'historicCaseId'])
    },
    data: function() {
      return {
        tab: null,
        loading: false,
        processDefinitionKey: 0,
        theProcessName: '',
        historicVars: [],
        historicHeaders: [
          { text: this.$t('CASES.HISTORIC.VIEW_CASE.FIELDS.VAR_NAME'), align: 'start', sortable: true, value: 'variableName' },
          { text: this.$t('CASES.HISTORIC.VIEW_CASE.FIELDS.VAR_VAL'), value: 'value', sortable: true },
          { text: this.$t('CASES.HISTORIC.VIEW_CASE.FIELDS.TIMESTAMP'), value: 'time', sortable: true }
        ],
        obfuscateDialog: false,
        obfuscateTitle: '',
        obfuscateText: '',
        obfuscateConfirmDialog: false,
        obfuscateConfirmTitle: '',
        obfuscateConfirmText: '',
        obfuscateHeaders: [
          { text: this.$t('CASES.HISTORIC.VIEW_CASE.FIELDS.VAR_NAME'), align: 'start', sortable: true, value: 'name' },
          { text: this.$t('CASES.HISTORIC.VIEW_CASE.FIELDS.VAR_VAL'), value: 'value', sortable: true }
        ],
        obfuscateItems: [],
        obfuscateData: []
      }
    },
    created() {
      this.loading = true;
      this.refreshTaskData();

      this.unsubscribe = this.$store.subscribe((mutation) => {

        if(mutation.type === 'HISTORIC_TASKS') {
          for(let i = 0; i < this.historicTasks.length; i++) {
            this.processDefinitionKey = this.historicTasks[0].processDefinitionKey
            let taskId = this.historicTasks[i].id;
            this.historicVars[`${taskId}`] = [];
            for(let j = 0; j < this.historicTasks[i].varData.length; j++) {
              let value = '';
              if(this.historicTasks[i].varData[j].variableName != 'users' && this.historicTasks[i].varData[j].variableName != 'groups' && this.historicTasks[i].varData[j].variableName != 'allUsersGroups' && this.historicTasks[i].varData[j].variableName != 'portalPassword') {
                if(this.historicTasks[i].varData[j].value != null && this.historicTasks[i].varData[j].value.toString().startsWith("[{")) {
                  let valueArr = JSON.parse(this.historicTasks[i].varData[j].value);
                  
                  if(valueArr[0].items) {
                    let items = valueArr[0].items;
                    
                    for(let k = 0; k < items.length; k++) {
                      let itemKeys = Object.keys(items[k]);
                      value += 'Row ' + (k + 1) + ': [';
                      itemKeys.forEach(item => {
                        value += item + ': ' + items[k][item] + ', ';
                      });
                      value = value.replace(/,\s*$/, "");
                      value += '], ';
                    }
                    value = value.replace(/,\s*$/, "");
                  }else {
                    // Do nothing
                  }
                }else {
                  if(this.historicTasks[i].varData[j].variableName == 'processName') {
                    this.theProcessName = this.historicTasks[i].varData[j].value;
                  }
                  value = this.historicTasks[i].varData[j].value;
                }

                let payload = {
                  id: this.historicTasks[i].varData[j].id,
                  variableName: this.historicTasks[i].varData[j].variableName,
                  value: value,
                  time: this.historicTasks[i].varData[j].time
                };
                this.historicVars[`${taskId}`].push(payload);
              }
            }
          }
          this.loading = false;
        }
      });
    },
    beforeDestroy() {
      this.unsubscribe();
    },
    methods: {
      close() {
        this.$router.push({ name: 'HistoricCases' });
      },
      refreshTaskData() {
        let payload = {
          'id': this.instanceId
        }
        this.$store.dispatch('getHistoricTasks', payload);
      },
      obfuscate() {
        this.obfuscateTitle = this.$t('CASES.HISTORIC.VIEW_CASE.OBFUSCATE_DATA.TITLE') + this.historicTasks[0].caseId;
        this.obfuscateText = this.$t('CASES.HISTORIC.VIEW_CASE.OBFUSCATE_DATA.DESC');

        let payload = {
          processInstanceId: this.historicTasks[0].processInstanceId
        };

        this.$store.dispatch('getHistoricVariables', payload).then( () => {
          for(let i = 0; i < this.historicVariables.length; i++) {
            if(this.historicVariables[i].name != 'users' && this.historicVariables[i].name != 'groups' && this.historicVariables[i].name != 'allUsersGroups' && this.historicVariables[i].name != 'portalPassword') {
              this.obfuscateItems.push({ name: this.historicVariables[i].name, value: this.historicVariables[i].value, id: this.historicVariables[i].id });
            }
          }
        });
        
        this.obfuscateDialog = true;
      },
      confirmObfuscation() {
        this.obfuscateDialog = false;
        for(let i = 0; i < this.obfuscateData.length; i++) {
          this.$store.dispatch('deleteHistoricVariable', this.obfuscateData[i].id);
        }
        this.updateLog('Historic', 'Obfuscated', this.historicTasks[0].caseId, this.theProcessName, 'Historic case ' + this.historicTasks[0].caseId + ' data obfuscated.');
        this.obfuscateConfirmTitle = this.$t('CASES.HISTORIC.VIEW_CASE.OBFUSCATE_DATA.CONFIRM_TITLE');
        this.obfuscateConfirmText = this.$t('CASES.HISTORIC.VIEW_CASE.OBFUSCATE_DATA.CONFIRM_TEXT');
        this.obfuscateConfirmDialog = true;
      },
      cancelObfuscation() {
        this.obfuscateDialog = false;
        this.obfuscateItems = [];
        this.obfuscateData = [];
      },
      obfuscateConfirmClose() {
        this.obfuscateConfirmDialog = false;
        this.refreshTaskData();
      },
      updateLog(cat, op, caseId, process, msg) {
        let dt = new Date();
        let dateTime = new Intl.DateTimeFormat('en-GB', 
          {
            day: 'numeric',
            month: 'numeric', 
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false
          }).format(dt);

        if(caseId == null) {
          caseId = 0;
        }

        let logData = {
          'category': cat,
          'userId': this.$store.state.currentUser,
          'caseId': caseId,
          'processName': process,
          'taskName': null,
          'operation': op,
          'msg': msg,
          'dateTime': dateTime,
        };
        this.$store.dispatch('updateOpLog', logData);
      }
    }
  }
</script>